import React from "react";
import ReactPlayer from "react-player";
import './glimpse.css';

function Glimpse() {
    return (
        <div className="glimpse">
            <h2 className="compTitle">Get a Glimpse</h2>
            <p>Experience the conference before it even begins! Check out our collection of promo videos to get a glimpse into the atmosphere, presentations, and networking opportunities that await you at the conference</p>
            <div style={{display: 'flex', gap: '3vmax', padding: '5vmax 0', justifyContent: 'center'}}>
                <ReactPlayer url="https://www.youtube.com/watch?v=b7xePppEUIU" height={'20vmax'} />
            </div>
        </div>
    )
}

export default Glimpse;